package com.oscarherreros.appcalculo.web

import kotlinx.browser.document
import org.w3c.dom.Element
import org.w3c.dom.HTMLElement

/** Crea un elemento [tag] con la clase [className] y el texto [text], y lo añade al final de este. */
@Suppress("UNCHECKED_CAST")
fun <T : HTMLElement> Element.child(tag: String, className: String? = null, text: String? = null): T {
    val element = document.createElement(tag) as T
    if (className != null) element.className = className
    if (text != null) element.textContent = text
    appendChild(element)
    return element
}

fun Element.div(className: String? = null, text: String? = null): HTMLElement = child("div", className, text)

fun Element.paragraph(className: String? = null, text: String? = null): HTMLElement = child("p", className, text)

fun Element.span(className: String? = null, text: String? = null): HTMLElement = child("span", className, text)
